// @flow
import * as React from 'react';
import styled from 'styled-components';
import Container from './Container';

import ButtonIcon from './ButtonIcon';
import TextStrong from './TextStrong';

type TProps = {
  onChange: (value: string) => void,
  error?: ?string,
  mask?: ?string,
};

const StyledInput = styled.input`
  height: 50px;
  padding-left: 16px;
  padding-right: 46px;
  font-family: InterSemiBold;
  font-size: 16px;
  width: 100%;
  border-color: ${props => props.error ? 'red' : '#000'};
  border-style: solid;
  border-width: 1px;
  border-radius: 2px;
`;

export default function InputGeneralAccountNumber(props: TProps): React.Node {
  const [rawValue, setRawValue] = React.useState('');

  const toDisplay = value => value.split(/(\d{4})/g).filter(Boolean).join(' ');
  const fromDisplay = (value) => value.replace(/\D/g, '');
  const _onChange = (event) => {
    const value = fromDisplay(event.target.value);
    setRawValue(value);
    props.onChange(value);
  };

  return (
    <Container>
      <Container flex centered fullwidth height="50px" relative>
        <StyledInput
          {...props}
          placeholder="Account number"
          value={toDisplay(rawValue)}
          onChange={_onChange} />
        <Container flex centered absolute fullheight right={16} fill="white">
          <TextStrong>{props.mask}</TextStrong>
          <Container ml={12}><ButtonIcon name="shield-lock-fill" /></Container>
        </Container>
      </Container>
      {props.error && (
        <Container flex align="center" py={16} ml={2}>
          <Container mr={8}>
            <ButtonIcon name="exclamation-triangle" color="red" />
          </Container>
          <TextStrong>{props.error}</TextStrong>
        </Container>
      )}
    </Container>
  );
}
